<template>
    <div>
        <b-modal id="modalAide" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>
                Aide
            </template>
            <div class="d-block text-center" v-html="aide">
                {{ aide }}
            </div>
            <b-button class="mt-3 btn-success" block @click="$bvModal.hide('modalAide')">Fermer</b-button>
        </b-modal>

        <div class="col-3 text-center">
            <i class="fa fa-question-circle-o fa-2x " aria-hidden="true" v-b-modal.modalAide
               @click="modalAide(idAide)"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Aide",
        props: ['token', 'site', 'user', 'racine', 'userId','idAide'],
        data() {
            return {
                blob:null,imagePath:null,dataUrl:null,aide:'vide'
            };
        },
        methods:
        {
            modalAide(id) {
                fetch(this.racine + this.site + 'api/aides/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(response => {
                    response.json().then(json => {
                        if (json != undefined) {
                            this.aide = json['aide']
                            console.log(this.aide)
                        }
                    })
                })
            },
        }
    }
</script>

<style scoped>

</style>